import { render } from "./UploadResultModal.vue?vue&type=template&id=d4da8d64&scoped=true&bindings={}"
import script from "./UploadResultModal.vue?vue&type=script&lang=ts"
export * from "./UploadResultModal.vue?vue&type=script&lang=ts"

import "./UploadResultModal.vue?vue&type=style&index=0&id=d4da8d64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d4da8d64"

export default script